import { ErrorMessage, Heading, Layout, RadioButton } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getContractMonths } from "../../data/contract";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";

export const ContractMonths = () => {
    const { t } = useTranslation(["question2page"]);
    const { values, errors, setFieldValue, touched } = useFormikContext<IMatchMakerAnswers>();
    return (
        <>
            <Heading level={2} className="u-font-size-fs2"> {t("question2page:contrat-months.title")}</Heading>

            <Layout>
                {getContractMonths().map((month) => (
                    <Layout.Item default="1/3" key={month}>
                        <RadioButton
                            aria-invalid={!!(touched["duration"] && errors["duration"])}
                            aria-errormessage={`selectableTileGroup-${"duration"}`}
                            name="duration"
                            aria-labelledby={`selectableTileGroup-${"duration"}`}
                            id={`duration_${month}`}
                            onChange={() => setFieldValue("duration", month)}
                            checked={values.duration === month}
                            required
                        >
                            {month}
                        </RadioButton>
                    </Layout.Item>
                ))}
            </Layout>
            {touched["duration"] && errors["duration"] && (
                <Layout>
                    <Layout.Item>
                        <ErrorMessage id={`selectableTileGroup-${"duration"}`}>
                            {errors["duration"] as string}
                        </ErrorMessage>
                    </Layout.Item>
                </Layout>
            )}
        </>
    );
};
